import React from "react";
import { ListItemButton, ListItemText, SvgIconTypeMap, useTheme, Box, Chip } from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { Step, setStep, useStep } from "../../../state/map";
import { useAppDispatch } from "@/state/types";

type Props = {
  icon: OverridableComponent<SvgIconTypeMap>;
  primary: string;
  secondary: string
  step: Step;
  showFreeChip?: boolean;
}

export const SectionTitle = ({ icon: Icon, primary, secondary, step, showFreeChip = false }: Props) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const currentStep = useStep();
  const expanded = step === currentStep;

  const handleClick = () => {
    // Toggle: if clicking on the already-open step, collapse it
    if (expanded) {
      dispatch(setStep(null));
    } else {
      dispatch(setStep(step));
    }
  };

  return (
    <>
      <ListItemButton
        onClick={handleClick}
        style={{
          backgroundColor: expanded ? theme.palette.background.paper : theme.palette.background.default,
          display: "flex",
          justifyContent: "start",
          flexWrap: "wrap",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <ListItemIcon>
          <Icon fontSize="large"/>
        </ListItemIcon> */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
          <ListItemText
            primary={primary}
            primaryTypographyProps={{ variant: "h4", letterSpacing: 0.3 }}
            // secondaryTypographyProps={{ color: "primary", }}
          />
          {showFreeChip && (
            <Chip 
              label="Free" 
              size="small" 
              color="success"
              sx={{ height: '22px', fontSize: '0.7rem', fontWeight: 600 }}
            />
          )}
        </Box>
        {expanded ? <ExpandLess color="primary"/> : <ExpandMore color="primary"/>}
      </ListItemButton>
    </>
  );
};
